import { BusinessObj } from "auth"
import { BaseEntity, MinimalEntity } from "BaseEntity"
import { UserPermissionDTO, UserRole } from "models"


export interface PermissionPayload {
	menuList: UserMenuItem[]
	permissionList: UserPermissionDTO[]
	user: MccUserDTO
	userRoles: UserRole[]
}

export interface PermissionState {
	menuList: UserMenuItem[]
	businessObjList: BusinessObj[]
	user: MccUserDTO | null
	userRoles: UserRole[]
	permissionList: UserPermissionDTO[]
}

export type UserState = {
	permissions: PermissionState
	permsLoading: boolean
}

export interface UserMenuItem extends MinimalEntity {
	screen: {
		name: string
		tcn: number
		uiPath: string
	}
	userMenuList?: UserMenuItem[]
}

export interface Contact extends MinimalEntity {
	email: string
	canUpdate: boolean
}
export interface Role extends BaseEntity {
	infoOnly: boolean
	disabled: boolean
}

export class MccUserDTO extends BaseEntity {
	disabled: boolean
	createUser: MinimalEntity
	updateUser: MinimalEntity
	contact: Contact
	roleList: Role[]
	userRoles: UserRole[]
	menuList: UserMenuItem[]
	permissionList: UserPermissionDTO[]
}

export class MccUser extends MccUserDTO { }

export class PermissionsResponseDTO {
	userModel: { user: MccUserDTO }
	permissionsList: UserPermissionDTO[]
	userRoles: UserRole[]

	get user(): MccUserDTO {
		return this.userModel?.user
	}
}

export class PermissionsResponse extends PermissionsResponseDTO {
	get menuList(): UserMenuItem[] {
		return this.user?.menuList ?? []
	}
	get permissionList(): UserPermissionDTO[] {
		return this.permissionsList ?? []
	}
	get getUserRoles(): UserRole[] {
		return this.userRoles ?? []
	}
}
